import initialState from './initialState';

const notificationReducer = (state = initialState.notifications, action) => {
    switch (action.type) {
        case 'NOTIFICATION_SHOW':
            return [...state, action.payload];
        case 'NOTIFICATION_HIDE':
            return state.filter(notification => notification.id !== action.id);
        default:
            return state;
    }
};

export default notificationReducer;
